import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Refresh } from "@material-ui/icons";
import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export default class RefreshSchema extends Component {
  constructor(props) {
    super();
    this.state = {
      showModal: false,
      disableSubmit: false,
      updated_by: cookies.get("email"),
    };
    this.handleshowModal = this.handleshowModal.bind(this);
  }

  handleshowModal = (e) => {
    this.setState({ showModal: !this.state.showModal });
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableSubmit: true });
    axios
      .post("api/refresh_basic/" + this.props.id, {
        updated_by: this.state.updated_by,
      })
      .then((res) => {
        this.props.parentCallback(true);
        this.setState({ showModal: false, disableSubmit: false });
      });
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-info btn-sm float-right ml-10"
          title="Refresh Schema"
          onClick={this.handleshowModal}
        >
          <Refresh />
        </button>
        <Modal
          size="md"
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: !this.state.showModal })}
        >
          <Modal.Header closeButton>
            <h4>Refresh Basic Schema</h4>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.handleSubmit} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  This will refresh basic schema for all employees, Are you
                  sure?
                </div>
              </div>
              <div className="float-right">
                <button
                  type="submit"
                  className="btn btn-primary btn-sm mr-2"
                  disabled={this.state.disableSubmit}
                >
                  Refresh
                </button>
                <button
                  onClick={this.handleshowModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
